const OldTransactions = () => {
	const n = 'Old Transaction';
	return <div>{n}</div>;
};

export default OldTransactions;
